var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgBinder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 5a1 1 0 001 1h11v15H9.119A3.118 3.118 0 016 17.881V5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 6H7.538C6.688 6 6 5.328 6 4.5S6.689 3 7.538 3H17"
  }))));
}

export default "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E %3Cg fill='none' fill-rule='evenodd' stroke-linejoin='round' stroke-width='2'%3E %3Cpath d='M0 2c0 .552.448 1 1 1h11v15H3.119C1.396 18 0 16.604 0 14.881h0V2z' transform='translate(6 3)'/%3E %3Cpath d='M9 3H1.538C.688 3 0 2.328 0 1.5S.689 0 1.538 0H11' transform='translate(6 3)'/%3E %3C/g%3E %3C/svg%3E";
export { SvgBinder as ReactComponent };